import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b9bf3ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = {
  key: 0,
  class: "book-info-list-container"
}
const _hoisted_3 = { class: "list-header" }
const _hoisted_4 = { class: "header-contents" }
const _hoisted_5 = { class: "line-count" }
const _hoisted_6 = { class: "line-count-txt" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-area" }, null, -1 /* HOISTED */))
const _hoisted_8 = {
  ref: "bookInfoWrapper",
  class: "book-info-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      appear: "",
      name: "slide-up"
    }, {
      default: _withCtx(() => [
        ($setup.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("header", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, "총 " + _toDisplayString($props.bookInfos.length) + "건", 1 /* TEXT */)
                  ]),
                  _createVNode($setup["InlineSvg"], {
                    class: "img-close-btn",
                    src: require('@/assets/icons/x-icon.svg'),
                    alt: "닫기",
                    onClick: $setup.onClickClose
                  }, null, 8 /* PROPS */, ["src"])
                ]),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.bookInfos, (bookInfo) => {
                  return (_openBlock(), _createBlock($setup["BookHistoryRow"], {
                    key: `${bookInfo.id}-${bookInfo.seatNo}`,
                    bookInfo: bookInfo,
                    onClick: ($event: any) => (_ctx.$emit('onClickBookInfo', bookInfo))
                  }, null, 8 /* PROPS */, ["bookInfo", "onClick"]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    ($setup.bookInfoWrapper)
      ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
          key: 0,
          container: $setup.bookInfoWrapper
        }, null, 8 /* PROPS */, ["container"]))
      : _createCommentVNode("v-if", true)
  ]))
}